<template>
  <v-expansion-panel expand class="grey lighten-3" popout>
    <v-expansion-panel-content
      :class="{'red lighten-5' : type == 'CREDIT', 'blue lighten-5' : type == 'ADDITION'}"
      v-model="docketEntry"
    >
      <div slot="header">
        <h1 class="title grey--text text--darken-1">
          <v-icon class="mr-1">create_new_folder</v-icon>
          <span v-if="!!adjustmentData">{{getProperCase(type)}}</span>
          <span v-else>Docket</span>
          Entry
        </h1>
      </div>
      <div style="height: 1px;" class="grey lighten-2 mx-3 my-1"></div>
      <v-card :class="{'red lighten-5' : type == 'CREDIT', 'blue lighten-5' : type == 'ADDITION'}">
        <v-card-text>
          <v-form @submit.prevent="submitDocket()" ref="docketForm">
            <layout-no-padding class="flex-container-space-between vertical-center-container">
              <v-flex xs12 sm3>
                <v-autocomplete
                  @keydown.enter.prevent="preventDefault()"
                  label="Billing Period"
                  color="indigo"
                  prepend-icon="date_range"
                  :items="type == 'CREDIT' || type == 'ADDITION' ? allBillingPeriods : openBillingPeriods"
                  v-model="billingPeriod"
                ></v-autocomplete>
              </v-flex>
              <template v-if="!!adjustmentData">
                <v-flex xs12 sm3>
                  <v-checkbox label="Adjust RCTI" v-model="adjustRcti" color="primary" hide-details></v-checkbox>
                  <v-checkbox label="Adjust Bill" v-model="adjustBill" color="primary" class="mt-2"></v-checkbox>
                </v-flex>

                <v-flex xs12 sm3></v-flex>
              </template>

              <v-flex xs12 sm3 class="grey--text font-weight-bold">
                <div class="flex-container-end">
                  <v-dialog v-model="docketNotesDialog" max-width="700px">
                    <v-btn icon flat large color="grey" slot="activator" class="mr-0">
                      <v-badge :color="$store.state.global.pages.docket.color" overlap left>
                        <v-icon>note</v-icon>
                        <span slot="badge">{{trips.length}}</span>
                      </v-badge>
                    </v-btn>
                    <v-card>
                      <v-card-title>
                        <div class="headline">Docket Notes</div>
                      </v-card-title>
                      <v-card-text>
                        <v-text-field
                          color="indigo"
                          label="Docket Notes"
                          prepend-icon="note"
                          v-model="notes"
                        ></v-text-field>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </div>

                <div
                  xs3
                  sm3
                  class="grey--text font-weight-bold text-xs-right flex-end-container"
                  v-if="!!totalBreaks || !!totalTravel"
                >
                  <span v-if="!!totalBreaks">Total breaks: {{totalBreaks}}hrs</span>
                  <span v-if="!!totalBreaks && !!totalTravel">/</span>
                  <span v-if="!!totalTravel">Total travel: {{totalTravel}}hrs</span>
                </div>
              </v-flex>
            </layout-no-padding>

            <layout-no-padding>
              <v-flex sm6 md3>
                <v-autocomplete
                  label="* Site"
                  :autofocus="!Object.keys(selectedAllocation).length"
                  ref="siteField"
                  prepend-icon="location_on"
                  :items="sites"
                  item-text="siteName_projectName"
                  item-value="id"
                  v-model="site"
                  no-data-text="An error occured"
                  :rules="siteRules"
                  :loading="loadingSites"
                  color="indigo"
                ></v-autocomplete>
              </v-flex>

              <v-flex sm6 md3>
                <v-text-field
                  label="* External Docket #"
                  color="indigo"
                  prepend-icon="insert_drive_file"
                  v-model="externalRef"
                  :rules="externalRefRules"
                  :error-messages="externalRefErrors"
                  :loading="externalRefErrorsLoading"
                ></v-text-field>
              </v-flex>
              <v-flex sm6 md3>
                <date-picker-wrapper
                  v-model="date"
                  :rules="dateRules"
                  label="Docket Date"
                  color="indigo"
                ></date-picker-wrapper>
              </v-flex>
              <v-flex sm6 md3>
                <date-picker-wrapper
                  v-model="dateReceived"
                  :rules="dateRules"
                  label="Date Received"
                  color="indigo"
                ></date-picker-wrapper>
              </v-flex>
              <v-flex sm6 md4>
                <v-autocomplete
                  label="* Vehicle Rego"
                  prepend-icon="local_shipping"
                  :items="filteredVehicles"
                  item-value="id"
                  item-text="vehicleName_vehicleType"
                  v-model="vehicleId"
                  no-data-text="Select a vehicle..."
                  :rules="regoRules"
                  :loading="loadingVehicles"
                  color="indigo"
                  clearable
                >
                  <v-tooltip slot="prepend" bottom>
                    <v-icon @click="showAddVehicle()" slot="activator">local_shipping</v-icon>
                    <span>Add new vehicle?</span>
                  </v-tooltip>
                </v-autocomplete>
              </v-flex>
              <v-flex sm6 md4>
                <v-autocomplete
                  label="* Driver"
                  prepend-icon="person"
                  :items="filteredDrivers"
                  item-text="driverName_contractorName"
                  item-value="id"
                  v-model="driverId"
                  no-data-text="Select a contractor..."
                  :rules="driverRules"
                  :loading="loadingDrivers"
                  color="indigo"
                  clearable
                >
                  <v-tooltip slot="prepend" bottom>
                    <v-icon @click="showAddDriver()" slot="activator">person</v-icon>
                    <span>Add new driver?</span>
                  </v-tooltip>
                </v-autocomplete>
              </v-flex>
              <v-flex sm6 md4>
                <v-autocomplete
                  label="Sub-Contractor"
                  color="indigo"
                  prepend-icon="recent_actors"
                  :items="filteredContractors"
                  item-text="name"
                  item-value="id"
                  v-model="contractorId"
                  :rules="contractorRules"
                  :loading="loadingContractors"
                  clearable
                ></v-autocomplete>
              </v-flex>

              <v-flex
                xs12
                class="text-xs-right pb-4"
                style="align-self: flex-end;"
                v-if="!!hasTrips"
              >
                <v-btn icon flat color="grey" @click="clearFormDialog = !clearFormDialog">
                  <v-icon>clear_all</v-icon>
                </v-btn>
                <v-btn
                  :color="$store.state.global.pages.docket.color"
                  :disabled="!hasTrips"
                  type="submit"
                  dark
                  outline
                  :loading="addingDocket"
                >Commit Docket</v-btn>
              </v-flex>
            </layout-no-padding>
          </v-form>
        </v-card-text>
      </v-card>

      <!-- ADD DRIVER COMPONENT-->
      <v-dialog
        v-model="addDriverDialog"
        max-width="500px"
        lazy
        @keydown.esc="addDriverDialog = false"
      >
        <add-driver @close="addDriverDialog = false" parentStore="dockets"></add-driver>
      </v-dialog>
      <!-- ADD VEHICLE COMPONENT -->
      <v-dialog
        v-model="addVehicleDialog"
        max-width="500px"
        lazy
        @keydown.esc="addVehicleDialog = false"
      >
        <add-vehicle @close="addVehicleDialog = false" parentStore="dockets"></add-vehicle>
      </v-dialog>
      <!-- CLEAR FORM DIALOG -->
      <v-dialog max-width="400px" v-model="clearFormDialog">
        <v-card>
          <v-card-title>
            <div class="headline">Are you sure you want to clear the form and all its trips?</div>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="clearFormDialog = false" :color="primaryGrey">Cancel</v-btn>
            <v-btn flat color="primary" @click="resetForm(); clearFormDialog = false;">Clear</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import DocketValidation from '@/services/validation/docketValidation'
import DocketService from '@/services/requests/docketService'
import DriverService from '@/services/requests/driverService'
import VehicleService from '@/services/requests/vehicleService'
import ContractorService from '@/services/requests/contractorService'
import SiteService from '@/services/requests/siteService'
import BillingPeriods from '@/services/mixins/billingPeriods'
import FormatDates from '@/services/mixins/formatDates'

import AddDriver from '@/components/drivers/addDriver'
import AddVehicle from '@/components/vehicles/addVehicle'
import DatePickerWrapper from '@/components/ui/datePickerWrapper'
import MakePdf from '@/components/trips/actions/makePdf'

// import FilterContractorProjects from '@/services/mixins/filterContractorProjects'
import FilterDriverVehicles from '@/services/mixins/filterDriverVehicles'
import getDrivers from '@/services/mixins/getMasterFiles/getDrivers'
import getVehicles from '@/services/mixins/getMasterFiles/getVehicles'
import getContractors from '@/services/mixins/getMasterFiles/getContractors'
import getSites from '@/services/mixins/getMasterFiles/getSites'

export default {
  components: {
    AddDriver,
    AddVehicle,
    DatePickerWrapper,
    MakePdf
  },
  name: 'DocketControl',
  mixins: [
    DocketValidation,
    BillingPeriods,
    FormatDates,
    // FilterContractorProjects,
    FilterDriverVehicles,
    getDrivers,
    getVehicles,
    getContractors,
    getSites
  ],
  data() {
    return {
      // contractors: [],
      // loadingContractors: false,
      // loadingSites: false,
      // loadingDrivers: false,
      // loadingVehicles: false,
      externalRefErrorsLoading: false,
      docketEntry: true,
      showContractorFilter: false,
      addDriverDialog: false,
      addVehicleDialog: false,
      dateMenu: false,
      addingDocket: false,
      docketNotesDialog: false,
      useOverrideCost: false,
      adjustRcti: false,
      adjustBill: false,
      clearFormDialog: false,
      driverId: null,
      contractorId: null,
      projectId: null
    }
  },
  methods: {
    showAddVehicle() {
      if (this.$store.state.user.userAuthClass.contractorWrite)
        this.addVehicleDialog = true
      return
    },
    showAddDriver() {
      if (this.$store.state.user.userAuthClass.contractorWrite)
        this.addDriverDialog = true
      return
    },
    checkExternalRef() {
      this.externalRefErrorsLoading = true
      return DocketService.checkDocket({
        externalRef: this.externalRef,
        siteId: this.site
      })
        .then(result => {
          this.externalRefErrorsLoading = false
          return []
        })
        .catch(err => {
          this.externalRefErrorsLoading = false
          return [err.response.data.message]
        })
    },
    submitDocket() {
      if (!this.$refs.docketForm.validate()) {
        this.snack({ text: 'Please correct form errors', color: 'red' })
        return
      }
      if (this.type != 'DOCKET' && !this.adjustRcti && !this.adjustBill) {
        this.snack({
          text:
            'Please adjust either Bills, Rctis or both for credits / additions.',
          color: 'red'
        })
        return
      }

      if (this.hasTrips) {
        //Check validity of trips
        this.addDocket()
      } else {
        //console.log("No Trips");
        this.snack({ text: 'Please enter 1 or more trips', color: 'red' })
      }
    },
    addDocket() {
      this.addingDocket = true
      var docket = {
        siteId: this.site,
        externalRef: this.externalRef,
        date: this.date,
        dateReceived: this.dateReceived,
        billingPeriod: this.billingPeriod,
        driverId: this.driverId,
        vehicleId: this.vehicleId,
        notes: this.notes,
        trips: this.trips,
        totalBreaks: this.totalBreaks,
        totalTravel: this.totalTravel,
        useAltRate: this.useAltRate,
        useNightRate: this.useNightRate,
        useOverrideCost: this.useOverrideCost,
        docketRateId: this.docketRateId,
        allocationId: this.selectedAllocation.id,
        contractorId: this.contractorId,
        type: this.type,
        adjustRcti: this.adjustRcti,
        adjustBill: this.adjustBill
      }

      console.log(docket)

      DocketService.addDocket(docket)
        .then(result => {
          this.$store.commit('dockets/addToArrayState', {
            prop: 'dockets',
            value: result.data.result.docket
          })

          for (var trip of result.data.result.trips) {
            trip.new = true
            this.$store.commit('trips/addToArrayState', {
              prop: 'trips',
              value: trip
            })
          }
          if (!!result.data.result.updatedAllocation) {
            this.$store.commit('allocations/updateArrayStateById', {
              prop: 'allocations',
              editedValue: result.data.result.updatedAllocation
            })
          }
          this.snack({
            text: 'Docket was successfully added!',
            color: 'green'
          })

          // CREATE ADJUSTMENT PDF
          if (docket.type != 'DOCKET') {
            var pdfDocket = result.data.result.trips[0].docket
            pdfDocket.trips = result.data.result.trips
            pdfDocket.adjustRcti = this.adjustRcti
            pdfDocket.adjustBill = this.adjustBill
            this.$emit('addedAdjustment', pdfDocket)
            this.adjustmentData = null
          } else {
            this.$emit('addedDocket')
          }

          this.resetForm()
          this.addingDocket = false
          this.commitDocket = false
        })
        .catch(err => {
          console.log(err)
          this.snack({ text: err.response.data.message, color: 'red' })
          this.addingDocket = false
        })
    },
    resetForm() {
      this.selectedAllocation = {}
      this.$store.dispatch('dockets/resetForm')
      this.$store.dispatch('trips/resetTripOnDocketSubmitted')
      // this.date = "";
      this.externalRef = ''
      this.useOverrideCost = false
      this.adjustRcti = false
      this.adjustBill = false
      this.contractorId = null
      this.driverId = null
      this.vehicleId = null
      this.$refs.docketForm.resetValidation()
      this.$refs.siteField.focus()
    },
    // getContractors() {
    //     this.loadingContractors = true;
    //     ContractorService.getAllContractors().then(result => {
    //         this.loadingContractors = false;
    //         this.contractors = result.data.result;
    //         this.contractors.unshift({name: "All", id: null})
    //     }).catch(err => {
    //         this.loadingContractors = false;
    //         console.log(err);
    //     });
    // },
    // getSites() {
    //     this.loadingSites = true;
    //     SiteService.getAllSites().then(result => {
    //         this.loadingSites = false;
    //         this.sites = result.data.result;
    //     }).catch(err => {
    //         this.loadingSites = false;
    //         console.log(err);
    //     });
    // },
    // getDrivers() {
    //     this.loadingDrivers = true;
    //     DriverService.getAllDrivers().then(result => {
    //         this.loadingDrivers = false;
    //         this.drivers = result.data.result;
    //     }).catch(err =>{
    //         this.loadingDrivers = false;
    //         console.log("Error, get drivers");
    //         return [];
    //     });
    // },
    // getVehicles() {
    //     this.loadingVehicles = true;
    //     VehicleService.getAllVehicles().then(result => {
    //         this.loadingVehicles = false;
    //         this.vehicles = result.data.result;
    //     }).catch(err =>{
    //         this.loadingVehicles = false;
    //         console.log("Error, get vehicles");
    //         return [];
    //     });
    // },
    // filterByContractor(listName, contractorId) {
    //     return this[listName].filter(record => {
    //         return record.contractor.id == contractorId
    //     });
    // },
    initAllocation(val) {
      if (!!Object.keys(val).length) {
        this.driverId = val.driverId
        this.vehicleId = val.vehicleId
        this.site = val.siteId
        this.date = this.makeComputerDate(val.date)
      }
    },
    initAdjustment(val) {
      this.driverId = val.docket.driver.id
      this.billingPeriod = val.docket.billingPeriod
      this.vehicleId = val.docket.vehicle.id
      this.site = val.docket.site.id
      this.date = this.makeComputerDate(val.docket.date)
      this.dateReceived = this.makeComputerDate(val.docket.dateReceived)
      this.externalRef =
        val.docket.externalRef + '-' + this.type.substring(0, 2)
      this.trips = val.trips
    },
    preventDefault() {
      //console.log('prevented default');
    },
    getSiteObj() {
      var id = this.site
      var result = this.sites.filter(obj => {
        return obj.id === id
      })
      this.siteObj = result[0]
      this.projectId = result[0].projectId
    }
  },
  computed: {
    type() {
      if (!!this.adjustmentData) {
        return this.adjustmentData.type
      } else {
        return 'DOCKET'
      }
    },
    //MODEL SELECTED ALLOCATION FROM STORE
    selectedAllocation: Store.getSet({
      store: 'dockets',
      prop: 'selectedAllocation'
    }),
    //MODEL ADJUSTMENT DATA FROM STORE
    adjustmentData: Store.getSet({ store: 'dockets', prop: 'adjustmentData' }),
    //MODEL NECESSARY MULTI-COMPONENT-ACCESSIBLE ARRAYS TO DATA STORE
    // drivers: Store.getSet({store: 'drivers', prop: 'drivers'}),
    // sites: Store.getSet({store: 'sites', prop: 'sites'}),
    // vehicles: Store.getSet({store: 'vehicles', prop: 'vehicles'}),
    //MODEL SELECTED FORM VALUES TO DATA STORE
    // contractor: Store.getSet({store: 'dockets', prop: 'contractor'}),
    // driver: Store.getSet({store: 'dockets', prop: 'driver'}),
    // vehicle: Store.getSet({store: 'dockets', prop: 'vehicle'}),
    vehicleId: Store.getSet({ store: 'dockets', prop: 'vehicleId' }),
    site: Store.getSet({ store: 'dockets', prop: 'site' }),
    siteObj: Store.getSet({ store: 'dockets', prop: 'siteObj' }),
    notes: Store.getSet({ store: 'dockets', prop: 'notes' }),
    date: Store.getSet({ store: 'dockets', prop: 'date' }),
    dateReceived: Store.getSet({ store: 'dockets', prop: 'dateReceived' }),
    externalRef: Store.getSet({ store: 'dockets', prop: 'externalRef' }),
    billingPeriod: Store.getSet({ store: 'shared', prop: 'billingPeriod' }),
    totalBreaks: Store.getSet({ store: 'trips', prop: 'totalBreaks' }),
    totalTravel: Store.getSet({ store: 'trips', prop: 'totalTravel' }),
    docketRateId: Store.getSet({ store: 'dockets', prop: 'docketRateId' }),
    useNightRate: Store.getSet({ store: 'trips', prop: 'useNightRate' }),
    useAltRate: Store.getSet({ store: 'trips', prop: 'useAltRate' }),
    tripUseOverrideCost: Store.getSet({
      store: 'trips',
      prop: 'useOverrideCost'
    }),
    commitDocket: Store.getSet({ store: 'dockets', prop: 'commitDocket' }),
    trips: Store.getSet({ store: 'dockets', prop: 'trips' }),

    //OBJECTS CALCULATED FROM SELECTED DRIVER AND VEHICLE TO GET ASSOCIATED CONTRACTOR ID
    // driverObj () {
    //     var id = this.driver;
    //     var result = this.drivers.filter(obj => {
    //         return obj.id === id
    //     })
    //     return result[0];
    // },
    // vehicleObj () {
    //     var id = this.vehicle;
    //     var result = this.vehicles.filter(obj => {
    //         return obj.id === id
    //     })
    //     return result[0];
    // },

    //FILTERING DRIVERS AND VEHICLES BY CONTRACTOR. THESE ARRAY PRPOPS ARE USED DIRECTLY IN TEMPLATE
    // filteredDrivers() {
    //     if(!!this.contractor) {
    //         return this.filterByContractor('drivers', this.contractor)
    //     } else {
    //         return this.drivers;
    //     }
    // },
    // filteredVehicles() {
    //     if(!!this.contractor) {
    //         return this.filterByContractor('vehicles', this.contractor)
    //     } else {
    //         return this.vehicles;
    //     }
    // },
    hasTrips() {
      return this.trips.length > 0
    }
  },
  asyncComputed: {
    externalRefErrors() {
      if (this.externalRef.length > 2) {
        return this.checkExternalRef()
      } else {
        return []
      }
    }
  },
  watch: {
    commitDocket(val) {
      if (!!this.commitDocket) {
        //console.log("Submitting Docket from Hot Key");
        this.submitDocket()
        this.commitDocket = false
      }
    },
    tripUseOverrideCost(val) {
      if (!this.useOverrideCost) {
        this.useOverrideCost = this.tripUseOverrideCost
      }
    },
    site(val) {
      if (!!val) {
        //console.log('Site changed: ',val);

        this.getSiteObj()
      }
    }, //WATCH DRIVER AND VEHICLE SELECTED VALUES TO CHANGE SELECTED CONTRACTOR TO ASSOCIATED ID, triggering data synchronization
    // driver(val) {
    //     if(!!val) {
    //         //if(!!this.driverObj) {
    //             this.contractor = this.driverObj.contractor.id;
    //         //}
    //     }
    // },
    // vehicle(val) {
    //     if(!!val) {
    //         //if(!!this.vehicleObj) {
    //             this.contractor = this.vehicleObj.contractor.id;
    //         //}
    //     }
    // },
    driverId(val) {
      if (!!val) {
        //if(!!this.driverObj) {
        this.contractorId = this.driverObj.contractor.id
        //}
      }
    },
    vehicleId(val) {
      if (!!val) {
        //if(!!this.vehicleObj) {
        this.contractorId = this.vehicleObj.contractor.id
        //}
      }
    },
    //WATCH SELECTED ALLOCATION TO SET PRE SET DATA VALUES WHEN SELECTED
    selectedAllocation(val) {
      this.initAllocation(val)
    },
    adjustmentData(val) {
      if (!!val) {
        this.initAdjustment(val)
      }
    }
  },
  mounted() {
    // this.getContractors()
    // this.getSites()
    // this.getDrivers()
    // this.getVehicles()
    this.initAllocation(this.selectedAllocation)
    if (!!this.adjustmentData) {
      this.initAdjustment(this.adjustmentData)
    }
  }
}
</script>

<style scoped>
.v-dialog__container {
  align-self: flex-end;
}

.rounded-card {
  border-radius: 6px;
  border-top-left-radius: 6px !important;
  border-top-right-radius: 6px !important;
}
</style>
